<script setup>
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import DataTablesButtons from "datatables.net-buttons-bs5";
import DataTablesSelect from "datatables.net-select-bs5";
import "datatables.net-buttons/js/buttons.html5";

import { defineProps, defineEmits } from "vue";
import useRangeSectionsTable from "@/scripts/Utilities/RangeSectionsTable";

DataTable.use(DataTablesCore);
DataTable.use(DataTablesButtons);
DataTable.use(DataTablesSelect);

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const closeModal = () => {
  emit("update:modelValue", false);
};

const { tableData, columns, tableOptions } = useRangeSectionsTable();
</script>

<template>
  <div v-if="modelValue && !loading">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="closeModal"></div>
      <div class="modal-dialog">
        <div class="modal-content bg-dark text-white">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">RANGE SECTIONS</h3>
              <button
                type="button"
                class="close text-white"
                @click="closeModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="table-responsive">
              <div class="card-body p-0">
                <DataTable
                  :data="tableData"
                  :columns="columns"
                  :options="tableOptions"
                  class="table table-hover table-spacing text-nowrap"
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";

.modal-dialog {
  width: 90vw !important;
  max-width: 100vw !important;
  height: 90vh !important;
  margin: 5vh auto !important;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}

.modal-content {
  width: 100% !important;
  max-width: 100vw !important;
  height: 100% !important;
  border-radius: 12px !important;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}
.card-body.p-0 {
  padding-bottom: 0 !important;
}
</style>
